var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5193 7.42377H15.5183C13.9552 7.42377 12.4518 6.81436 11.3367 5.72541C9.88074 4.29257 7.61117 4.20287 6.06156 5.45548V12.1091C8.24478 11.109 10.9047 11.5014 12.7223 13.2863C14.173 14.7137 16.4507 14.7993 18.0088 13.5423V6.85636C17.2264 7.21291 16.3702 7.40179 15.4984 7.40179L15.5193 7.42377ZM19.4716 14.889C19.7854 14.7203 20 14.3879 20 14.0075V5.0162C20 4.67808 19.8364 4.38375 19.586 4.20378C19.1957 3.90674 18.6385 3.93126 18.2861 4.2848C16.733 5.80333 14.2539 5.80333 12.7106 4.2848C10.3809 1.998 6.66719 1.998 4.34739 4.28579C4.31752 4.31577 4.27769 4.35573 4.24783 4.39569C3.99094 4.68828 3.9374 5.0829 4.07031 5.42031V21.0008C4.07031 21.5503 4.50839 21.9998 5.06594 21.9998C5.61353 21.9998 6.06156 21.5503 6.06156 21.0008V14.4484C7.61121 13.1943 9.88192 13.2835 11.3384 14.7169C12.4535 15.8058 13.9569 16.4153 15.52 16.4153L15.4902 16.3923C16.953 16.3923 18.3716 15.8606 19.4716 14.889Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.ed9d3b4d85aa4b687fad044f6f634dfc.svg";
export { ForwardRef as ReactComponent };